import { Box, Button, Container, styled, Typography, useTheme } from "@mui/material";

import SuccessPattern from "assets/images/success-pattern.png";

import Dialog from "@mui/material/Dialog";
import { SuccessCheckIcon } from "assets/Icon";

function SuccessModal({
  open,
  onClose,
  variant,
  children,
  allowClickAway = true,
  title,
  subtitle
}) {
  const theme = useTheme()
  return (
    <DialogStyle
      open={open}
      keepMounted
      maxWidth="xs"
      onClose={allowClickAway ? onClose : () => { }}
      aria-describedby="alert-dialog-slide-description"
    >
      <BoxIcon>
        <SuccessCheckIcon fill={theme.palette.modules.successModalBg} stroke={theme.palette.modules.successModalBgBorder} />
        <SuccessPatternImg src={SuccessPattern} alt="" />
      </BoxIcon>

      <Typography color={'success.main'} fontSize={"24px"} textAlign={"center"} fontWeight={600}>
        {title}
      </Typography>

      <Typography color={'text.secondary'} variant={"h6"} textAlign={"center"} mt={1}>
        {subtitle}
      </Typography>

      <DialogContainer>{children}</DialogContainer>

      <Button color="success" fullWidth onClick={onClose}>
        Close
      </Button>
    </DialogStyle>
  );
}

const DialogStyle = styled(Dialog)(({ theme }) => ({
  zIndex: "999999",

  ".MuiPaper-root": {
    borderRadius: "8px",
    overflow: "initial",
    width: "100% ",
    padding: theme.spacing(4)
  },
}));

const DialogContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(6, 0, 2),
}));

const SuccessPatternImg = styled('img')(({ theme }) => ({
  position: "absolute",
  maxWidth: "160px",
  zIndex: "0"
}));

const BoxIcon = styled(Box)(({ theme }) => ({
  paddingBottom: theme.spacing(5),
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  "svg": {
    width: "60px",
    height: "60px",
    zIndex: "1"
  },
}));

export default SuccessModal;
